import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import StyledTextField from 'common/theme/fields/StyledTextfield';

function TextAreaFieldAdapter({ helperText = '', input, meta, ...rest }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const size = useMemo(() => (isDesktop ? 'medium' : 'small'), [isDesktop]);

  const onChange = (event) => {
    const {
      target: { type, value }
    } = event;
    const formattedValue = type === 'number' ? Number(value) : value;

    input.onChange(formattedValue);
  };

  // Contador de caracteres cuando el campo declara un límite (inputProps.maxLength).
  const maxLength = rest.inputProps?.maxLength;
  const currentLength = (input.value ?? '').length;
  const baseHelper = meta.touched && meta.invalid ? meta.error : helperText;
  const helper =
    maxLength != null ? (
      <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
        <Box component="span">{baseHelper}</Box>
        <Box
          component="span"
          sx={{ flexShrink: 0, color: currentLength >= maxLength ? 'gold.main' : 'inherit' }}>
          {currentLength}/{maxLength}
        </Box>
      </Box>
    ) : (
      baseHelper
    );

  return (
    <StyledTextField
      {...input}
      {...rest}
      onChange={onChange}
      error={meta.touched ? meta.invalid : false}
      helperText={helper}
      size={size}
    />
  );
}

TextAreaFieldAdapter.propTypes = {
  helperText: PropTypes.string,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired
};

export default TextAreaFieldAdapter;
